import { InjectionToken } from '@angular/core';

export const EventMapperService = new InjectionToken<void>('EventMapperService');
